module.exports = __webpack_public_path__ + "img/2.c56d0be4.png";